import { Navigate, Outlet } from 'react-router-dom'
import {isUserLoggedIn, getUserType } from '../config/userSession';

const ProtectedManagerRoutes = () => {
  
return (
    isUserLoggedIn() && getUserType() === 'Manager' ? <Outlet/> : <Navigate to='/login'/>
  )
}

export default ProtectedManagerRoutes;